import React, { useEffect } from 'react';
import { FB_BASE } from '../styles/variables';
import { darken } from '@material-ui/core/styles';
import SkeletonButton from '../Button/SkeletonButton';
import FacebookIcon from '@material-ui/icons/Facebook';
import T from 'i18n-react';
import withStyles from '@material-ui/core/styles/withStyles';

const StyledButton = withStyles((theme) => ({
  root: {
    color: theme.palette.common.white,
    backgroundColor: FB_BASE,
    '&:hover': {
      backgroundColor: darken(FB_BASE, 0.1),
    },
  },
}))(SkeletonButton);

const SDK_ID = 'fbSdk';

export const loadSdk = () => {
  if (!document.getElementById(SDK_ID)) {
    const fbRoot = document.createElement('div');

    fbRoot.id = SDK_ID;

    const script = document.createElement('script');
    script.innerHTML = `
      window.fbAsyncInit = function() {
        FB.init({
          appId            : '${process.env.FACEBOOK_APP_ID}',
          autoLogAppEvents : true,
          xfbml            : true,
          version          : 'v23.0'
        });
      };
    `;
    fbRoot.appendChild(script);

    const scriptSrc = document.createElement('script');
    scriptSrc.async = true;
    scriptSrc.defer = true;
    scriptSrc.crossOrigin = 'anonymous';
    scriptSrc.src = 'https://connect.facebook.net/en_US/sdk.js';

    fbRoot.appendChild(scriptSrc);

    document.body.appendChild(fbRoot);
  }
};

declare global {
  interface Window {
    FB: any;
  }
}

interface FbButtonProps {
  loaded?: boolean;
  url: string;
}

// Refer to https://developers.facebook.com/docs/sharing/reference/share-dialog/
const FbButton = ({ loaded, url }: FbButtonProps) => {
  useEffect(loadSdk, []);

  const handleClick = () => {
    window.FB?.ui?.(
      {
        display: 'popup',
        method: 'share',
        href: url,
      },
      function (response) {},
    );
  };

  return (
    <StyledButton
      loaded={loaded}
      startIcon={<FacebookIcon />}
      color="primary"
      variant="contained"
      onClick={handleClick}
    >
      {T.translate('share')}
    </StyledButton>
  );
};

export default FbButton;
